import React from 'react'
import assets from '../../assets'
import { useT } from '../../i18n'
import style from '../../styles/components/authenticate.module.scss'
import Close from '../utils/Close'
import Modal from './Modal'

export enum AuthenticateType {
    SIGN_IN = 'SIGN_IN',
    REGISTER = 'REGISTER',
    FORGOT_PASSWORD = 'FORGOT_PASSWORD'
}

interface AuthenticateProps {
    onClose?: () => void
    authenticateType?: AuthenticateType
    layout?: 'split' | 'classic'
    children?: React.ReactNode | React.ReactNode[]
}

const Authenticate = (props: AuthenticateProps) => {
    const t = useT()
    const layout = props.layout ?? 'split'

    if (layout === 'classic') {
        return <Modal animate>
            <div className={props.authenticateType === AuthenticateType.REGISTER ? style.registerContainer : style.signInContainer}>
                <div className='d-flex justify-content-between px-4 pt-4'>
                    <div className={style.logoContainer}>
                        <img src={assets.images.logo} alt='Do2Do logo' />
                    </div>
                    <Close onClose={props.onClose} />
                </div>
                <div className='my-2 px-4'>
                    {props.authenticateType === AuthenticateType.SIGN_IN && <div className={style.headerText}>{t("Sign In")}</div>}
                    {props.authenticateType === AuthenticateType.REGISTER && <div className={style.headerText}>{t("Create Account")}</div>}
                    {props.authenticateType === AuthenticateType.FORGOT_PASSWORD && <div className={style.headerText}>{t("Reset Password")}</div>}
                </div>
                {props.children}
            </div>
        </Modal>
    }

    const panelTitle = props.authenticateType === AuthenticateType.REGISTER
        ? t('Looks like you are new here!')
        : props.authenticateType === AuthenticateType.FORGOT_PASSWORD
            ? t('Reset Password')
            : t('Login')

    const panelSubtitle = props.authenticateType === AuthenticateType.REGISTER
        ? t('Sign up with your email and start shopping with Do2Do')
        : props.authenticateType === AuthenticateType.FORGOT_PASSWORD
            ? t("Enter your email and we'll send you a new password")
            : t('Get access to your Orders, Wishlist and Recommendations')

    const bgImage = props.authenticateType === AuthenticateType.REGISTER
        ? '/food_3.jpg'
        : '/food_1.jpg'

    return <Modal animate>
        <div className={style.splitModal}>
            <div className={style.leftPanel} key={props.authenticateType}>
                <img
                    className={style.leftBg}
                    src={bgImage}
                    alt=''
                    aria-hidden
                />
                <div className={style.leftOverlay} />
                <div className={style.leftContent}>
                    <span className={style.panelEyebrow}>{t('Do2Do')}</span>
                    <h2 className={style.panelTitle}>{panelTitle}</h2>
                    <p className={style.panelSubtitle}>{panelSubtitle}</p>
                </div>
            </div>
            <div className={style.rightPanel}>
                <div className={style.closeWrap}>
                    <Close onClose={props.onClose} />
                </div>
                {props.children}
            </div>
        </div>
    </Modal>
}

export default Authenticate
